import { render } from "./MunicipiosView.vue?vue&type=template&id=f1dbf1ec"
import script from "./MunicipiosView.vue?vue&type=script&lang=js"
export * from "./MunicipiosView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__